export const MINIMUM_PASSWORD_LENGTH = 7;
export const MAXIMUM_PASSWORD_LENGTH = 128;
/** Represents minimum acceptable zxcvbn score */
export const MINIMUM_PASSWORD_STRENGTH = 3;
export const EMAIL_VALIDATION_REGEX = /^.+@.+\..{2,6}$/;
